import store from './store';
import { i18n } from '../i18n';
import { getDefaultConfig, DialogOptions, getDefaultBtn } from './business';
import Index from '../index.vue';
import { loadComponent } from '@tencent/wphk-components-common/utils/load-component';
import { DialogButtonItem } from '@tencent/wphk-ui';

const cacheKey = Symbol('dialog');

// @ts-ignore
function update(config: DialogOptions) {
  Object.keys(config).forEach((key) => {
    if (typeof store.dialog[key] !== 'undefined') {
      store.dialog[key] = config[key];
    }
  });
}

export function showDialog(options: DialogOptions) {
  loadComponent(Index, cacheKey);
  const config = Object.assign(getDefaultConfig(), {
    show: true,
  }, options);
  update(config);
}

export function hideDialog() {
  const config = Object.assign(getDefaultConfig(), {
    show: false,
  });
  update(config);
}

/**
 * 获取报错跳转按钮配置
 * @param errLinkName 跳转按钮名称
 * @param errLinkUrl 跳转地址
 * @returns 按钮数组
 */
export function getErrorLinkBtn(errLinkName: string, errLinkUrl: string): DialogButtonItem | undefined {
  if (errLinkName && errLinkUrl) {
    return {
      text: errLinkName,
      click() {
        hideDialog();
        location.href = errLinkUrl;
      },
    };
  }
}

export function showBusinessError(error?: any, options: DialogOptions = {}) {
  if (error) {
    if (typeof error === 'string') {
      showDialog(Object.assign({}, {
        title: error,
      }, options));
      return;
    }
    const { title, retmsg, message, errMsg, error_link_name: errLinkName, error_link_url: errLinkUrl } = error;

    // 如果是接口报错且有返回错误跳转地址时，展示跳转按钮
    const linkBtn = getErrorLinkBtn(errLinkName, errLinkUrl);
    const newBtns = [getDefaultBtn(), linkBtn].filter(btn => btn);

    const newOptions = Object.assign(options, {
      btns: options.btns || newBtns,
    });

    showDialog(Object.assign({}, {
      title: title || retmsg || message || errMsg || error.err_msg || i18n('系统繁忙'),
    }, newOptions));
    return;
  }

  showDialog(Object.assign({}, {
    title: i18n('系统繁忙'),
  }, options));
}

export function showSimpleDialog(content: string) {
  loadComponent(Index, cacheKey);
  const config = Object.assign(getDefaultConfig(), {
    show: true,
  });
  config.content = content;
  console.log(config);
  update(config);
}
